import { computed } from 'vue';
import { useAppStore } from 'store/modules/appStore';

export function getLoadingImg() {
    const appStore = useAppStore();
    const systemData = computed(() => appStore.getSystemData);
    // const aliasNum = systemData.value?.aliasNum || 503;

    const loadingIcon = systemData.value?.loadingIcon || '';
    // const loadingImg = {
    //     any: '/assets/images/loading_any.gif',
    //     503: '/assets/images/loading_503.gif',
    //     603: '/assets/images/loading_603.gif',
    //     604: '/assets/images/loading_any.gif',
    //     605: '/assets/images/loading_605.gif',
    //     606: '/assets/images/loading_606.gif',
    //     607: '/assets/images/loading_607.gif',
    // };
    // const imgPath = loadingImg[aliasNum as keyof typeof loadingImg] || loadingImg['any'];
    return loadingIcon;
}
